import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { UsersResponse } from 'models/users.model';

const getUrl = ({
  host,
  page,
  size,
  search,
  projectId,
  filter,
}: {
  host: string;
  projectId?: string;
  page?: number;
  size?: number;
  search?: string;
  filter?: string;
}) => {
  const params = new URLSearchParams();
  projectId && params.append('project_id', projectId);
  page && params.append('page[number]', `${page}`);
  size && params.append('page[size]', `${size}`);
  !!search && params.append('search', search);
  !!filter && params.append('filter', filter);

  return `${host}/users?${params}`;
};

export const GetUserList = async ({
  host,
  token,
  page,
  size,
  search,
  projectId,
  filter,
}: {
  host: string;
  token: string;
  projectId?: string;
  page?: number;
  size?: number;
  search?: string;
  filter?: string;
}) => {
  try {
    const url = getUrl({ host, page, size, search, projectId, filter });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 30000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<UsersResponse>;
    return data;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
